(() => {
  if (window.niaashCatalogBound) return;
  window.niaashCatalogBound = true;
  let controller;
  const pl = document.documentElement.lang.startsWith('pl');
  const normalize = text => text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');
  const filterFabrics = catalog => {
    const search=catalog.querySelector('[data-fabric-search]');if(!search)return;
    const words=normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    const cards=[...catalog.querySelectorAll('[data-product-card]')];let count=0;
    cards.forEach(card=>{const text=normalize(card.textContent);card.hidden=!words.every(word=>text.includes(word));if(!card.hidden)count++;});
    catalog.querySelector('[data-fabric-count]').textContent=pl?`${count} / ${cards.length} materiałów`:`${count} of ${cards.length} fabrics`;
    catalog.querySelector('[data-clear-fabric]').hidden=!search.value;
    const empty=catalog.querySelector('[data-fabric-empty]');if(empty)empty.hidden=count>0;
  };
  const refresh = () => {
    const catalog = document.querySelector('[data-catalog]');
    if (!catalog) return;
    filterFabrics(catalog);
    catalog.querySelectorAll('.ns-toolbar a,.ns-pagination a').forEach(a => {
      const u = new URL(a.href);
      if (u.pathname.includes('/collections/')) { u.hash = 'fabric-catalog'; a.href = u.href; }
    });
  };
  const load = async (url, push = true) => {
    const catalog = document.querySelector('[data-catalog]');
    if (!catalog) { location.assign(url); return; }
    controller?.abort(); controller = new AbortController();
    const signal = controller.signal;
    catalog.setAttribute('aria-busy', 'true');
    catalog.querySelector('[role=status]').textContent = pl ? 'Wczytywanie…' : 'Loading…';
    try {
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('catalog');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-catalog]');
      if (!next) throw new Error('catalog');
      if (signal.aborted) return;
      catalog.replaceWith(next);
      document.title = doc.title;
      if (push) history.pushState({niaashCatalog:true}, '', url);
      document.dispatchEvent(new CustomEvent('niaash:catalog'));
      refresh();
      next.focus({preventScroll:true});
      next.scrollIntoView({block:'start',behavior:'instant'});
      next.querySelector('[role=status]').textContent = pl ? 'Zaktualizowano wybór.' : 'Selection updated.';
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url);
    } finally { if (!signal.aborted) document.querySelector('[data-catalog]')?.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', e => {
    const clear=e.target.closest('[data-clear-fabric]');if(clear){const catalog=clear.closest('[data-catalog]');const input=catalog.querySelector('[data-fabric-search]');input.value='';filterFabrics(catalog);input.focus();return;}
    const compare = e.target.closest('[data-compare-toggle]');
    if (compare) { const panel=document.getElementById('catalog-compare'); panel.hidden=!panel.hidden;compare.setAttribute('aria-expanded',String(!panel.hidden));return; }
    const a=e.target.closest('[data-catalog] .ns-toolbar a,[data-catalog] .ns-pagination a');
    if (!a || e.button!==0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    const url=new URL(a.href);
    if (url.origin!==location.origin || !url.pathname.includes('/collections/')) return;
    e.preventDefault();load(url.href);
  });
  document.addEventListener('input',e=>{
    if(e.target.matches('[data-fabric-search]'))filterFabrics(e.target.closest('[data-catalog]'));
    if(e.target.matches('[data-compare-search]')){const query=normalize(e.target.value.trim());e.target.closest('#catalog-compare').querySelectorAll('tbody tr').forEach(row=>row.hidden=!normalize(row.textContent).includes(query));}
  });
  document.addEventListener('submit', e => {
    if (!e.target.matches('[data-catalog] .ns-sort')) return;
    e.preventDefault();const url=new URL(location.href);url.searchParams.delete('page');
    new FormData(e.target).forEach((v,k)=>url.searchParams.set(k,v));url.hash='fabric-catalog';load(url.href);
  });
  window.addEventListener('popstate',()=>{if(document.querySelector('[data-catalog]'))load(location.href,false);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
